import SingleOutputTextAreaView from "../../components/SingleOutputTextAreaView";
import sha256 from "crypto-js/sha256";
import sha512 from "crypto-js/sha512";
import md5 from "crypto-js/md5";
import sha1 from "crypto-js/sha1";
import sha224 from "crypto-js/sha224";
import sha384 from "crypto-js/sha384";
import sha3 from "crypto-js/sha3";
import ripemd160 from "crypto-js/ripemd160";

import GeneratorOptions from "./GeneratorOptions";

const hashAlgos = {
  sha256,
  md5,
  sha512,
  sha1,
  sha224,
  sha384,
  sha3,
  ripemd160,
};

const regEx = new RegExp(`${Object.keys(hashAlgos).join("|") + "|hash"}`, "gi");

const extractType = ({ pathname }) => {
  const type = pathname.match(regEx)
    ? pathname.match(regEx)[0]
    : pathname.match(regEx);
  return type?.toLowerCase() === "hash" ? "sha256" : type || "sha256";
};

const generate = ({ location: { pathname }, history }, text, { type }) => {
  const newPath = pathname.replace(regEx, type);
  newPath !== pathname && history.push(newPath);
  return hashAlgos[type](text);
};

const Index = ({ strings, toolStrings, location, history }) => (
  <SingleOutputTextAreaView
    onGenerate={(text, options) =>
      generate({ location, history }, text, options)
    }
    countText={toolStrings.hashLabel}
    strings={strings}
    toolStrings={toolStrings}
    options={{ type: extractType(location) }}
    optionsView={GeneratorOptions}
  />
);
export default Index;
